import React from "react";

const EtransferSecurityOptions = (props) => {
  const options = [
    {
      text: 'Qu’est-ce que la fraude par courriel, l’hameçonnage ou le harponnage, le référencement abusif ou l’hameçonnage par message texte?',
      handler: props.actionProvider.handleEtransferSecurityOptions1,
      id: 1,
    },
    {
      text: 'On m’a offert un poste d’agent de transfert de fonds. INTERAC s’associe-t-elle avec des entreprises de transferts de fonds?',
      handler: props.actionProvider.handleEtransferSecurityOptions2,
      id: 2
    },
    {
      text: 'Comment fonctionne l’escroquerie de ces entreprises de transferts de fonds?',
      handler: props.actionProvider.handleEtransferSecurityOptions3,
      id: 3
    },
    {
      text: 'Comment savoir si un emploi offert est lié à des activités frauduleuses? L’information semble très professionnelle.',
      handler: props.actionProvider.handleEtransferSecurityOptions4,
      id: 4
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container etransferSecurity-products'>{optionsMarkup}</div>;
};

export default EtransferSecurityOptions;